import { FunctionComponent } from "react";
import { Testimonial } from "../types";
import TestimonialsCard from "../TestimonialsCard";
import Carousel from "src/components/generic/Carousel";


interface TestimonialsGridProps {
  testimonials: Testimonial[];
}


const TestimonialsGrid: FunctionComponent<TestimonialsGridProps> = ({ testimonials }) => (
  <Carousel visibleItems={3} gap={2}>
    {testimonials.map((testimonial, index) => (
      <TestimonialsCard key={index} testimonial={testimonial} />
    ))}
  </Carousel>
);


export default TestimonialsGrid;




